export default "__VITE_ASSET__5lMbz6QW__"